import React, { memo } from 'react'
import Button from '@mui/material/Button'
import CloseIcon from '@mui/icons-material/Close'
import Box from '@mui/material/Box'
import sx from './styles'

const FilterItemButton = ({
  item, onDeleteItem, trash,
}) => {
  return (
    <Box mr={0.5}>
      <Button
        variant="outlined"
        sx={sx.button}
        onClick={() => onDeleteItem(item)}
        endIcon={trash ? false : <CloseIcon />}
      >
        {item}
      </Button>
    </Box>
  )
}

export default memo(FilterItemButton)
